<template>
  <BTable
    v-bind="$attrs"
    :selected="value"
    :headers="headers"
    :actions="actions"
    :list="list"
    :items-per-page-options="[-1]"
    v-on="$listeners || {}"
  >
    <template #item.name="{ header, data }">
      <v-tooltip v-if="data.is_default_topic" top>
        <template #activator="{ on }">
          <v-icon
            color="success"
            class="mr-2"
            v-on="on"
            v-text="'mdi-checkbox-marked-outline'"
          />
        </template>

        <span v-text="'Раздел по умолчанию'" />
      </v-tooltip>

      <router-link
        :to="header.getRoute(data)"
        v-text="data.name"
      />

      <span
        v-if="data.name_en"
        class="text--secondary"
        v-text="data.name_en"
      />
    </template>
    <template #item.is_hidden="{ data }">
      <v-tooltip bottom>
        <template #activator="{ on }">
          <v-icon
            :color="data.is_hidden ? 'error' : 'success'"
            class="mr-2"
            v-on="on"
            v-text="data.is_hidden ? 'mdi-eye-off-outline' :'mdi-eye-outline'"
          />
        </template>
        <span>{{ data.is_hidden ? 'Скрыто' : 'Отображается' }}</span>
      </v-tooltip>
    </template>
  </BTable>
</template>

<script>
import {
  TABLE_HEADERS,
  TABLE_ACTIONS,
} from '@/views/Topics/table-headers'

import BTableSimple from './BTableSimple.vue'

export default {
  name: 'BTableTopics',
  extends: BTableSimple,
  props: {
    value: Array,
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => TABLE_ACTIONS,
    },
    list: {
      type: Array,
    },
  },
}
</script>
